var _g, _mask, _g2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMcloudyN(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 434,
    height: 360,
    fill: "none",
    viewBox: "0 0 434 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_30_526)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_30_526)",
    fillRule: "evenodd",
    d: "M341.51 1.0861C336.359 0.370139 331.096 0 325.747 0C263.345 0 212.759 50.368 212.759 112.5C212.759 174.632 263.345 225 325.747 225C372.68 225 412.929 196.509 430 155.95C428.899 155.983 427.793 156 426.683 156C369.69 156 323.487 111.676 323.487 57C323.487 36.2527 330.14 16.996 341.51 1.0861Z",
    clipRule: "evenodd"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_30_526",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M319.761 360L150.358 360C67.3176 360 0 292.843 0 210C0 127.157 67.3176 60 150.358 60C217.131 60 273.738 103.423 293.354 163.507C301.767 161.22 310.622 160 319.761 160C375.122 160 420 204.771 420 260C420 315.228 375.122 360 319.761 360Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_30_526)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_30_526)",
    fillRule: "evenodd",
    d: "M319.761 360L150.358 360C67.3176 360 0 292.843 0 210C0 127.157 67.3176 60 150.358 60C217.131 60 273.738 103.423 293.354 163.507C301.767 161.22 310.622 160 319.761 160C375.122 160 420 204.771 420 260C420 315.228 375.122 360 319.761 360Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M150.358 360V359V360ZM319.761 360V361V360ZM293.354 163.507L292.403 163.817L292.698 164.721L293.616 164.472L293.354 163.507ZM150.358 361L319.761 361V359L150.358 359V361ZM-1 210C-1 293.397 66.7675 361 150.358 361V359C67.8676 359 1 292.288 1 210H-1ZM150.358 59C66.7675 59 -1 126.603 -1 210H1C1 127.712 67.8676 61 150.358 61V59ZM294.304 163.196C274.558 102.712 217.575 59 150.358 59V61C216.687 61 272.918 104.133 292.403 163.817L294.304 163.196ZM293.616 164.472C301.945 162.208 310.711 161 319.761 161V159C310.532 159 301.59 160.232 293.091 162.542L293.616 164.472ZM319.761 161C374.572 161 419 205.326 419 260H421C421 204.217 375.672 159 319.761 159V161ZM419 260C419 314.674 374.572 359 319.761 359V361C375.672 361 421 315.783 421 260H419Z",
    mask: "url(#path-2-inside-1_30_526)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_30_526",
    width: 246.241,
    height: 240,
    x: 187.759,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_30_526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30_526",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -25,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.529412 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect2_innerShadow_30_526"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_30_526",
    width: 420,
    height: 348.647,
    x: 0,
    y: 60,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 48.647
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect1_innerShadow_30_526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_526",
    x1: 225.564,
    x2: 388.013,
    y1: 0,
    y2: 257.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B87EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#3010AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_526",
    x1: 29.423,
    x2: 419.459,
    y1: 60,
    y2: 360.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcloudyN);
export default __webpack_public_path__ + "static/media/mcloudyN.901a7ee42275921f8dfefb80555e1ec9.svg";
export { ForwardRef as ReactComponent };